import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect directly to protocols page
    navigate('/protocols', { replace: true });
  }, [navigate]);

  return null;
};

export default Home;
